export default __webpack_public_path__ + "static/media/samsung-deals-found.e6b1320c.png";